import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { cartQueryKey } from '@hooks/useCart/useCart';
import { applyCoupon } from '@services/couponService';
import type { ShoppingCartDTO } from '@t/api.types';

export interface UseApplyCouponOptions {
  onSuccess?: (cart: ShoppingCartDTO) => void;
  onError?: (error: Error) => void;
}

export const useApplyCoupon = (
  sessionId: string,
  { onSuccess, onError }: UseApplyCouponOptions = {}
): UseMutationResult<ShoppingCartDTO, Error, string> => {
  const queryClient = useQueryClient();
  return useMutation<ShoppingCartDTO, Error, string>({
    mutationFn: (couponCode) => applyCoupon(sessionId, couponCode),
    onSuccess: (cart) => {
      queryClient.setQueryData<ShoppingCartDTO>(cartQueryKey(sessionId), cart);
      onSuccess?.(cart);
    },
    onError,
  });
};
